/* eslint-disable max-len */
import { VoidCallback } from '@deqo/foundation';
import { default as React, useCallback, useState } from 'react';
import { Manager, usePopper } from 'react-popper';
import { Flex } from 'reflexbox';
import styled from 'styled-components';
import { promptName } from '../../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../../Legacy';
import { CommandDispatcher } from '../../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../../concepts/resources/Icon';
import { Tip } from '../../../../ui/Tip';
import { useResolve } from '../../../Container';
import { PopperInner, PopperMount } from '../../../canvas/ui/PopperElements';
import { createVoteRound } from '../VotingCommands';
import { ActionItem, Box, Button, Colors, Float, Input, Prompt, Toggle } from './../../../../ui';

const LabelText = styled.div`
    color: ${Colors.primaryText};
    font-weight: 450;
`;

const Field = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.5rem;
`;

const HelpText = styled.div`
    font-size: 0.875rem;
    color: #abadb7;
`;

const InputSizer = styled.div`
    width: 10rem;
`;

const reduceAllocation = (value: string) => {
    let val = parseInt(value);
    val = isNaN(val) ? 0 : val;
    val = val < 0 ? 0 : val;
    val = val > 999 ? 999 : val;
    return val;
};

export const CreateVoteRoundPanel: LFC<{ dismiss: VoidCallback }> = ({ dismiss }) => {

    const [duplicates, setDuplicates] = useState(true);
    const [allocation, setAllocation] = useState(0);

    const dispatch = useResolve(CommandDispatcher);
    const onStart = useCallback(() => {
        dispatch(createVoteRound, [duplicates, allocation]);
        dismiss();
    }, [dismiss, duplicates, allocation]);

    return <Box width="25" padding="1">
        <Field>
            <LabelText>Allow Duplicate Voting</LabelText>
            <Toggle value={duplicates} onAction={() => setDuplicates(!duplicates)} />
        </Field>
        <HelpText>Controls whether participants can vote on the same item multiple times.</HelpText>
        <br />
        <Field>
            <LabelText>Vote Allocation</LabelText>
            <InputSizer>
                <Input compact
                    placeholder="Unlimited"
                    value={(allocation || '').toString()}
                    onChange={value => setAllocation(reduceAllocation(value))} />
            </InputSizer>
        </Field>
        <HelpText>Controls the number of votes each participant is allocated for the round.</HelpText>
        <br />
        <Flex id="voting-round" justifyContent="center">
            <Button variant="primary" onAction={onStart}>
                Start Round
            </Button>
        </Flex>
    </Box>;
};

export const CreateVoteRoundActionItemWithPopper: LFC<{ mode?: 'label' | 'icon', disabled?: boolean }> = ({ mode, disabled }) => {

    const [refElmt, setRefElmt] = useState(null);
    const [popElmt, setPopElmt] = useState(null);

    const { styles, attributes } = usePopper(refElmt, popElmt, {
        placement: 'top',
    });

    const [open, setOpen] = useState(false);
    const pn = promptName();

    return <Manager>
        {mode === 'label' ? (
            <ActionItem className={`ignore-${pn}`} ref={setRefElmt} disabled={disabled} grow pressable onClick={() => setOpen(x => !x)}>
                Start Voting Round
            </ActionItem>
        ) : (
            <Tip text="Start Voting Round" position="top" disabled={open}>
                <ActionItem className={`ignore-${pn}`} ref={setRefElmt} disabled={disabled} pressable onClick={() => setOpen(x => !x)}>
                    <Icon size="1" src="deqo://icons/deqo/add" />
                </ActionItem>
            </Tip>
        )}
        {open && <PopperMount ref={setPopElmt} style={styles.popper} {...attributes.popper}>
            <PopperInner direction="up">
                <Prompt name={pn} onAction={() => setOpen(false)}>
                    <Box padding="1">
                        <Float>
                            <CreateVoteRoundPanel dismiss={() => setOpen(false)} />
                        </Float>
                    </Box>
                </Prompt>
            </PopperInner>
        </PopperMount>}
    </Manager>;
};
